import "./Footer.css";
import { useTheme } from "@chakra-ui/react";

const Footer = () => {
    const theme = useTheme();
    return (
        <div
            className="footer"
            style={{
                backgroundColor: theme.colors.secondary,
                color: theme.colors.primary,
            }}
        >
            <div className="footerContainer">
                <p className="footerText">
                    Created by Anna Munro - 2022. Credits to Hemanth R:
                    github.com/hhhrrrttt222111 for inspiration.
                </p>
            </div>
        </div>
    );
};

export default Footer;
